import React from 'react';
import {connect} from "react-redux"
import { bindActionCreators } from "redux";
import debounce from "debounce";
import { convertSmartQuotes, isValidTextMessage } from "lib/text";

import {sendReply, setReplyDraft} from "state/teachers/actions";
import {getSchoolName, getSchoolReplyDraft} from "state/teachers/selectors";

const INPUT_DEBOUNCE_DELAY = 500;
const MAX_REPLY_LENGTH = 300;

class ReplyInput extends React.Component {
  
  static getDerivedStateFromProps(nextProps) {
    return {
      replyDraft: nextProps.replyDraft
    }
  }
  
  state = {}

  /**
   * Set school's replyDraft (on debounce timer)
   */
  setReplyDraft = debounce((replyDraft) => {
    this.props.setReplyDraft(this.props.schoolID, replyDraft);
  }, INPUT_DEBOUNCE_DELAY);

  /**
   * Callback for change event of textarea
   */
  onChange = (event) => {
    let replyDraft = this.textarea.value;
    // Remove smart quote characters
    replyDraft = convertSmartQuotes(replyDraft);
    // Check if the input is text message-compatible
    if (isValidTextMessage(replyDraft) && replyDraft.length <= MAX_REPLY_LENGTH) {
      this.setReplyDraft(replyDraft);
      this.setState({ replyDraft });
    } else {
      // Prevent invalid input
      event.preventDefault();
    }
  }

  onSend = () => {
    const { replyDraft } = this.state;
    let trimmedReplyDraft = replyDraft.trim();
    if (trimmedReplyDraft.length > 0) {
      // cancel any pending debounced calls to setReplyDraft
      this.setReplyDraft.clear();
      // dispatch an action to send the message
      this.props.sendReply(this.props.schoolID, trimmedReplyDraft);
      // clear the replyDraft from local state
      this.setState({ replyDraft: "" });
    }
  }

  refTextarea = (textarea) => {
    this.textarea = textarea;
    if (this.props.refInput !== undefined) {
      this.props.refInput(textarea);
    }
  }

  render() {

    const { replyDraft } = this.state;
    const hasReply = replyDraft.length > 0;

    const sendButtonClassList = ["reply-input__send-button"];
    if( !hasReply ) {
      sendButtonClassList.push("reply-input__send-button--disabled");
    }

    return (
      <div className="reply-input">
        <textarea className="reply-input__textarea" rows={1} maxLength={MAX_REPLY_LENGTH} ref={this.refTextarea} onChange={this.onChange} value={replyDraft} placeholder={`Reply to ${this.props.schoolName}`} />
        <button className={sendButtonClassList.join(" ")} onClick={this.onSend}></button>
      </div>
    );

  }
}

export default connect(
  (state, ownProps) => ({
    schoolName: getSchoolName(state, ownProps.schoolID),
    replyDraft: getSchoolReplyDraft(state, ownProps.schoolID)
  }),
  (dispatch, ownProps) => bindActionCreators({
    sendReply,
    setReplyDraft
  }, dispatch)
)(ReplyInput);



// WEBPACK FOOTER //
// ./src/components/teachers/messages/ReplyInput.js